<template>
	<div class="container">
		<b-row>
			<b-container>
				<h3 class="text-center py-2">
					<b><i>SALDOS INTERCOMPAÑIAS</i></b>
				</h3>

				<h5 class="text-center py-2">
					<b-row class="mb-4 justify-content-center align-items-center text-lg">
						<b-col md="auto" class="text-center px-3">
							<label class="d-block fw-bold fs-4 mb-3"><b>{{ labels.fecha_reporte }}:</b></label>
							<select v-model="dialogFechas"
								@click="isEmpty = true; intercos_detalle = []; intercos = []; fgl_detalle = false"
								class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
								<option value="">Seleccione...</option>
								<option v-for="(item, idx) in fechas" :key="'fecha-' + idx" :value="item.fecha">
									{{ item.fecha }}
								</option>
							</select>
						</b-col>

						<b-col md="auto" class="text-center px-3">
							<label class="d-block fw-bold fs-4 mb-3"><b>{{ labels.group }}:</b></label>
							<select v-model="grupoId" class="form-control form-control-lg w-auto mx-auto fs-5"
								style="min-width: 200px;">
								<option value="">Todos los grupos</option>
								<option v-for="grupo in listGrupos" :key="grupo.id" :value="grupo.id">
									{{ grupo.nombre }}
								</option>
							</select>
						</b-col>
					</b-row>

					<b-row class="mb-4 justify-content-center align-items-center">
						<b-col md="auto" class="text-center">
							<b-button variant="primary" @click="f_consultar()" class="btn-lg px-5 mx-2 fs-5">
								<b><i>{{ labels.consultar }}</i></b>
							</b-button>
							<b-button v-if="fgl_generado" variant="outline-primary" @click="f_generar()"
								:disabled="isVigenciaBloqueada"
								class="btn-lg px-5 mx-2 fs-5">
								<b><i>{{ labels.generar }}</i></b>
							</b-button>
						</b-col>
					</b-row>
				</h5>
			</b-container>
		</b-row>

		<b-row v-if="isLoading">
			<b-container class="text-center py-5">
				<b-col md="12">
					<div class="loading-spinner mb-3">
						<b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
					</div>
					<h4 class="text-primary">
						<b><i>Cargando información...</i></b>
					</h4>
				</b-col>
			</b-container>
		</b-row>

		<b-modal v-model="showGeneratingModal" title="Generando Intercompañías" hide-footer centered
			no-close-on-backdrop no-close-on-esc>
			<div class="text-center">
				<b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
				<h5 class="mt-3">
					<b><i>{{ generatingMessage }}</i></b>
				</h5>
				<p class="mt-2">{{ generatingSubMessage }}</p>
				<b-progress v-if="generatingProgress >= 0" class="mt-3">
					<b-progress-bar :value="generatingProgress" :label="`${generatingProgress}%`" variant="primary"
						striped animated>
					</b-progress-bar>
				</b-progress>
			</div>
		</b-modal>

		<b-row v-if="!isLoading && !isEmpty && !fgl_detalle && filteredIntercos.length > 0">
			<b-container class="pb-5">
				<md-table v-model="filteredIntercos" md-card md-fixed-header
					:class="{ 'balance-table': true, 'principal-table': true }" key="principal-table">

					<md-table-toolbar :key="selectionMode + '-' + selectedRows.length">
						<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
							<div style="flex: 1; text-align: center;">
								<h1 class="md-title">
									<b><i>SALDOS INTERCOMPAÑIAS</i></b>
								</h1>
							</div>

							<div style="display: flex; align-items: center; gap: 10px;">

								<b-button v-if="fgl_excel && !selectionMode" @click="excel(1)" variant="success"
									class="excel-btn">
									<span class="excel-btn-text">Excel General</span>
								</b-button>

								<b-button v-if="fgl_excel && !selectionMode" @click="toggleSelectionMode()"
									variant="info" class="excel-btn">
									<span class="excel-btn-text">Activar Selección</span>
								</b-button>

								<b-button v-if="fgl_excel && !selectionMode" @click="verHuerfanos()" variant="warning"
									class="excel-btn">
									<span class="excel-btn-text">Sin Conciliar</span>
								</b-button>

							</div>
						</div>
					</md-table-toolbar>
					<md-table-row slot="md-table-row" slot-scope="{ item }" :class="{
						'selected-row': isSelected(item),
						'selection-mode-row': selectionMode
					}" @click="handleRowClick(item)">
						<md-table-cell :md-label="labels.identificacion_origen"
							class="text-left border descripcion-cell">
							{{ item.identificacion_origen }}
						</md-table-cell>
						<md-table-cell :md-label="labels.identificacion_origen_desc"
							class="text-left border descripcion-cell">
							{{ f_compania(item.identificacion_origen) }}
						</md-table-cell>
						<md-table-cell :md-label="labels.saldo_origen" class="text-right border number-cell">
							{{ formato(item.saldo_origen) }}
						</md-table-cell>
						<md-table-cell :md-label="labels.identificacion_destino"
							class="text-left border descripcion-cell">
							{{ item.identificacion_destino }}
						</md-table-cell>
						<md-table-cell :md-label="labels.identificacion_origen_desc"
							class="text-left border descripcion-cell">
							{{ f_compania(item.identificacion_destino) }}
						</md-table-cell>
						<md-table-cell :md-label="labels.saldo_destino" class="text-right border number-cell">
							{{ formato(item.saldo_destino) }}
						</md-table-cell>
						<md-table-cell :md-label="labels.diferencia" class="text-right border number-cell">
							{{ formato(f_calcularDiferencia(item.saldo_origen, item.saldo_destino)) }}
						</md-table-cell>
						<md-table-cell :md-label="labels.secuencia" class="text-left border descripcion-cell">
							{{ item.secuencias || '—' }}
						</md-table-cell>
					</md-table-row>
				</md-table>

				<div v-if="selectionMode" class="d-flex align-items-center mt-3" style="gap: 10px;">

					<b-button @click="excelSelection()" :variant="selectedRows.length > 0 ? 'success' : 'secondary'"
						:disabled="selectedRows.length === 0" class="excel-btn download-btn">
						Descargar ({{ selectedRows.length }})
					</b-button>

					<b-button @click="toggleSelectionMode()" variant="warning" class="excel-btn">
						Cancelar Selección
					</b-button>

				</div>

				<div v-if="selectionMode" class="text-center mt-3">
					<div class="alert alert-info d-inline-block">
						<strong>Modo selección activo:</strong> Seleccione múltiples filas para descargar en Excel.
						Haga clic en "Descargar" para descargar el detalle de las filas seleccionadas o "Cancelar
						Selección" para volver al modo
						normal.
						<br><strong>Seleccionadas: {{ selectedRows.length }} fila(s)</strong>
					</div>
				</div>
			</b-container>
		</b-row>

		<b-row v-if="!isLoading && fgl_detalle">
			<b-container class="pb-5">
				<md-table v-model="intercos_detalle" md-card md-fixed-header
					:class="{ 'balance-table': true, 'detalle-table': true }" key="detalle-table">
					<md-table-toolbar>
						<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
							<div style="flex: 1; text-align: center;">
								<h1 class="md-title">
									<b><i>{{ f_titulo_cuenta() }}</i></b>
								</h1>
							</div>

							<div style="display: flex; align-items: center; gap: 10px;">
								<md-button v-if="fgl_excel" @click="excel(2)" class="md-fab md-primary">
									<md-icon>description</md-icon>
								</md-button>
							</div>
						</div>
					</md-table-toolbar>

					<md-table-row slot="md-table-row" slot-scope="{item}">
						<md-table-cell :md-label="labels.identificacion_origen"
							class="text-left border descripcion-cell">
							{{ item.identificacion_origen }}
						</md-table-cell>
						<md-table-cell :md-label="labels.cuenta_origen" class="text-left border descripcion-cell">
							{{ item.cuenta_origen }}
						</md-table-cell>
						<md-table-cell :md-label="labels.descripcion_origen" class="text-left border descripcion-cell">
							{{ item.descripcion_origen }}
						</md-table-cell>
						<md-table-cell :md-label="labels.saldo_origen" class="text-right border number-cell">
							{{ formato(item.saldo_origen) }}
						</md-table-cell>

						<md-table-cell :md-label="labels.identificacion_destino"
							class="text-left border descripcion-cell">
							{{ item.identificacion_destino }}
						</md-table-cell>
						<md-table-cell :md-label="labels.cuenta_destino" class="text-left border descripcion-cell">
							{{ item.cuenta_destino }}
						</md-table-cell>
						<md-table-cell :md-label="labels.descripcion_destino" class="text-left border descripcion-cell">
							{{ item.descripcion_destino }}
						</md-table-cell>
						<md-table-cell :md-label="labels.saldo_destino" class="text-right border number-cell">
							{{ formato(item.saldo_destino) }}
						</md-table-cell>

						<md-table-cell v-if="fgl_diferencia" :md-label="labels.diferencia"
							class="text-right border number-cell">
							{{ formato(item.diferencia) }}
						</md-table-cell>
					</md-table-row>
				</md-table>

				<div class="text-center mt-4">
					<b-button variant="outline-primary" @click="fgl_detalle = false" class="btn-lg px-4 mr-2">
						<h4><b><i>{{ labels.regresar }}</i></b></h4>
					</b-button>
					<b-button variant="outline-primary" @click="fgl_diferencia = !fgl_diferencia" class="btn-lg px-4">
						<h4><b><i>{{ labels.diferencia }}</i></b></h4>
					</b-button>
				</div>
			</b-container>
		</b-row>

		<b-row>
			<b-container v-if="!isLoading && isEmpty">
				<b-col md="2" class="mx-auto">
					<div class="success-svg mb-4" :class="{ active: isEmpty }">
						<img src="../../assets/imgs/file-2.svg" alt="warning" />
					</div>
				</b-col>
				<b-col md="12" class="justify-content-around">
					<span id="message" v-if="isEmpty">{{ labels.empty }}</span>
				</b-col>
			</b-container>
		</b-row>
	</div>
</template>

<script>
import Balance from "@/services/BalanceNiif"
import * as XLSX from "exceljs"
import Grupo from "@/services/Grupo"

export default {
	name: "Intercos",

	data: () => ({
		fgl_detalle: false,
		fgl_diferencia: false,
		muestra: false,
		isEmpty: true,
		isLoading: false,
		showDialog: false,
		showDialogEdit: false,
		dialogItem: {},
		intercos: [],
		filteredIntercos: [],
		intercos_detalle: [],
		vigencia: '',
		opcion: '',
		companias: [],
		fechas: [],
		dialogFechas: '',
		dialogReportes: 0,
		reportes: [],
		fgl_generado: false,
		fgl_reporte: 0,
		fgl_excel: true,
		titulo: 1,
		titulo_cuenta: '',
		listGrupos: [],
		grupoId: "",
		filteredCompany: [],
		selectedRows: [],
		selectionMode: false,
		showGeneratingModal: false,
		generatingMessage: "",
		generatingSubMessage: "",
		generatingProgress: -1,
		isGenerating: false,
	}),

	computed: {
		isVigenciaBloqueada() {
			return this.dialogFechas ? !this.$store.getters.isPeriodoEnabled(this.dialogFechas) : false
		},
		labels() {
			if (this.$store.state._language == "es-ES") {
				return {
					consultar: "Consultar",
					generar: "Generar",
					regresar: "Regresar",
					fecha_reporte: "Vigencia",
					identificacion_origen: "Nit",
					identificacion_origen_desc: "Compañia",
					saldo_origen: "Saldo Compañia",
					identificacion_destino: "Nit",
					identificacion_destino_desc: "Compañia",
					saldo_destino: "Saldo Compañia",
					cuenta_origen: "Cuenta",
					descripcion_origen: "Descripción",
					cuenta_destino: "Cuenta",
					descripcion_destino: "Descripción",
					diferencia: "Diferencia",
					reporte: "Reporte",
					empty: "No hay datos disponibles",
					modificar: "Modificar",
					group: "Grupo",
					secuencia: "Secuencia"
				}
			} else {
				return {
					consultar: "Consultar",
					generar: "Generate",
					regresar: "Back",
					fecha_reporte: "Validity",
					identificacion_origen: "Company",
					identificacion_origen_desc: "Company",
					saldo_origen: "Company Balance",
					identificacion_destino: "Company",
					identificacion_destino_desc: "Company",
					saldo_destino: "Company Balance",
					cuenta_origen: "Account",
					descripcion_origen: "Description",
					cuenta_destino: "Account",
					descripcion_destino: "Description",
					diferencia: "Difference",
					reporte: "Report",
					empty: "No data available",
					modificar: "Modify",
					group: "Group",
					secuencia: "Secuencia"
				}
			}
		},
		hasSelectedRows() {
			return this.selectedRows && this.selectedRows.length > 0;
		}
	},

	watch: {
		filteredIntercos(newVal, oldVal) {
			if (this.selectedRows.length > 0 && newVal !== oldVal) {
				this.selectedRows = this.selectedRows.filter(selected =>
					newVal.some(item =>
						item.identificacion_origen === selected.identificacion_origen &&
						item.identificacion_destino === selected.identificacion_destino
					)
				);

				if (this.selectedRows.length === 0) {
					this.$toast.info("Las selecciones anteriores ya no están disponibles con el filtro actual");
				}
			}
		},
		grupoId() {
			if (this.intercos.length > 0) {
				this.f_filterCompany();
			}
		},
		dialogFechas() {
			if (this.isVigenciaBloqueada) {
				this.$toast.error("La vigencia seleccionada está deshabilitada para generar el interco");
			}
		}
	},

	methods: {
		f_titulo() {
			if (this.$store.state._language == "es-ES") {
				return "SALDOS INTERCOMPAÑIAS"
			} else {
				return "INTERCOMPANY ACCOUNTS"
			}
		},

		f_titulo_cuenta() {
			return this.titulo_cuenta || "Detalle de Cuentas Intercompañía"
		},

		isSelected(item) {
			return this.selectedRows.some(
				row => row.identificacion_origen === item.identificacion_origen &&
					row.identificacion_destino === item.identificacion_destino
			);
		},

		f_calcularDiferencia(saldo_origen, saldo_destino) {
			const origen = this.toNumber(saldo_origen);
			const destino = this.toNumber(saldo_destino);

			return origen + destino;
		},

		toNumber(value) {
			if (!value) return 0;
			return Number(value.toString().replace(/,/g, ''));
		},

		handleRowClick(item) {
			if (this.selectionMode) {
				this.toggleRowSelection(item);
			} else {
				this.f_generar_detalle(item.identificacion_origen, item.identificacion_destino);
			}
		},

		closeGenerationModal() {
			this.showGeneratingModal = false;
			this.isGenerating = false;
			this.generatingProgress = 0;
			this.generatingMessage = '';
			this.generatingSubMessage = '';
		},

		forceCloseGenerationModal(message) {
			this.generatingMessage = "Proceso interrumpido";
			this.generatingSubMessage = message || "El proceso fue detenido por seguridad";
			this.generatingProgress = 0;

			setTimeout(() => {
				this.closeGenerationModal();
				this.$toast.warning("El proceso de generación fue interrumpido por tiempo de espera");
			}, 2000);
		},

		toggleRowSelection(r_interco) {
			const existingIndex = this.selectedRows.findIndex(
				row => row.identificacion_origen === r_interco.identificacion_origen &&
					row.identificacion_destino === r_interco.identificacion_destino
			);

			if (existingIndex > -1) {
				this.selectedRows.splice(existingIndex, 1);
				this.$toast.info(`Fila deseleccionada`);
			} else {
				this.selectedRows.push({
					identificacion_origen: r_interco.identificacion_origen,
					identificacion_destino: r_interco.identificacion_destino,
					compania_origen: this.f_compania(r_interco.identificacion_origen),
					compania_destino: this.f_compania(r_interco.identificacion_destino),
					saldo_origen: r_interco.saldo_origen,
					saldo_destino: r_interco.saldo_destino
				});
				this.$toast.info(`Fila seleccionada`);
			}

			if (this.selectedRows.length > 0) {
				console.log(`${this.selectedRows.length} fila(s) seleccionada(s)`);
			}
		},

		f_muestra(r_interco) {
			this.handleRowClick(r_interco);
		},

		toggleSelectionMode() {
			try {
				if (this.selectionMode) {
					this.selectionMode = false;
					this.selectedRows = [];
					if (this.$toast && this.$toast.info) {
						this.$toast.info("Modo selección cancelado");
					} else {
						console.info("Modo selección cancelado (toast no disponible)");
					}
					console.log("toggleSelectionMode -> desactivado");
				} else {
					this.selectionMode = true;
					if (this.$toast && this.$toast.info) {
						this.$toast.info("Modo selección activado. Haga clic en las filas para seleccionarlas.");
					} else {
						console.info("Modo selección activado (toast no disponible)");
					}
					console.log("toggleSelectionMode -> activado");
				}
			} catch (err) {
				console.error("Error en toggleSelectionMode:", err);
				this.selectionMode = !this.selectionMode;
			}
		},

		f_filterCompany() {
			console.log('=== INICIO FILTRO INTERCOS ===');
			console.log('Grupo seleccionado (ID):', this.grupoId);

			if (this.grupoId && this.intercos.length > 0) {
				const grupoIdNum = this.grupoId.toString();

				this.filteredIntercos = this.intercos.filter(interco => {
					const companiaOrigen = this.companias.find(c => c.identificacion === interco.identificacion_origen);
					const companiaDestino = this.companias.find(c => c.identificacion === interco.identificacion_destino);

					if (!companiaOrigen || !companiaDestino) return false;

					const gruposOrigen = companiaOrigen.id_grupos ?
						companiaOrigen.id_grupos.split(',').map(id => id.trim()) : [];

					const gruposDestino = companiaDestino.id_grupos ?
						companiaDestino.id_grupos.split(',').map(id => id.trim()) : [];

					const origenEnGrupo = gruposOrigen.includes(grupoIdNum);
					const destinoEnGrupo = gruposDestino.includes(grupoIdNum);

					console.log(`Interco: ${companiaOrigen.nombre} -> ${companiaDestino.nombre}, Origen en grupo: ${origenEnGrupo}, Destino en grupo: ${destinoEnGrupo}`);

					return origenEnGrupo && destinoEnGrupo;
				});

				console.log('Resultado del filtro intercos:', this.filteredIntercos.length, 'registros');
			} else {
				this.filteredIntercos = [...this.intercos];
				console.log('Mostrando TODAS las intercompañías:', this.filteredIntercos.length, 'registros');
			}

			this.isEmpty = this.filteredIntercos.length === 0;
			console.log('=== FIN FILTRO INTERCOS ===');
		},

		f_generar() {
			if (this.isVigenciaBloqueada) {
				this.$toast.error("La vigencia seleccionada está deshabilitada para generar");
				return;
			}
			if (this.isGenerating) {
				this.$toast.info("Ya se está generando la información. Por favor espere...");
				return;
			}

			this.showGeneratingModal = true;
			this.isGenerating = true;
			this.generatingMessage = "Generando información de Intercompañías";
			this.generatingSubMessage = "Iniciando proceso de generación...";
			this.generatingProgress = 0;

			const safetyTimeout = setTimeout(() => {
				if (this.isGenerating) {
					console.error("Timeout de seguridad activado - proceso colgado");
					this.forceCloseGenerationModal("Tiempo de espera agotado. El proceso está tomando más tiempo de lo esperado.");
				}
			}, 600000); 

			let progressInterval;

			progressInterval = setInterval(() => {
				if (this.generatingProgress < 85) { // Solo llegar hasta 85%, el resto lo completa la respuesta
					this.generatingProgress += 3;

					// Mensajes más descriptivos según el progreso
					if (this.generatingProgress < 20) {
						this.generatingSubMessage = `Preparando datos iniciales... ${this.generatingProgress}%`;
					} else if (this.generatingProgress < 50) {
						this.generatingSubMessage = `Procesando intercos... ${this.generatingProgress}%`;
					} else if (this.generatingProgress < 80) {
						this.generatingSubMessage = `Consolidando información... ${this.generatingProgress}%`;
					} else {
						this.generatingSubMessage = `Finalizando proceso... ${this.generatingProgress}%`;
					}
				}
			}, 5000);

			Balance.genereInterCompanias(this.vigencia, this.$store.state.userId)
				.then((response) => {
					clearTimeout(safetyTimeout);
					clearInterval(progressInterval);

					console.log("Respuesta de génereInterCompanias:", response);

					if (!response) {
						throw new Error("Respuesta vacía del servidor");
					}

					// Completar la barra de progreso al 100%
					this.generatingProgress = 100;
					this.generatingMessage = "¡Generación Completada!";
					this.generatingSubMessage = "La información de Intercompañías se ha generado exitosamente.";

					setTimeout(() => {
						this.closeGenerationModal();
						this.$toast.success("Información Intercompañías Generada");
						this.f_consultar();
					}, 1500);
				})
				.catch((error) => {
					clearTimeout(safetyTimeout);
					clearInterval(progressInterval);

					console.error("Error detallado en f_generar:", error);

					let errorMessage = "Ha ocurrido un problema al generar la información.";

					if (error.response && error.response.status === 500) {
						errorMessage = "Error interno del servidor. Contacte al administrador.";
					} else if (error.message && error.message.includes("timeout")) {
						errorMessage = "El tiempo de espera se agotó. El servidor está tardando demasiado.";
					} else if (error.message && error.message.includes("Network Error")) {
						errorMessage = "Error de conexión. Verifique su red e intente nuevamente.";
					}

					this.generatingMessage = "Error en la Generación";
					this.generatingSubMessage = errorMessage;
					this.generatingProgress = 0;

					setTimeout(() => {
						this.closeGenerationModal();
						this.$toast.error("Problema al generar información Intercompañías");
					}, 3000);
				});
		},

		f_consultar() {
			if (!this.dialogFechas) {
				this.$toast.warning("Por favor seleccione una vigencia");
				return;
			}

			// Si ya se está generando, no permitir consultar
			if (this.isGenerating) {
				this.$toast.info("Espere a que termine la generación actual");
				return;
			}

			this.muestra = false;
			this.vigencia = this.dialogFechas;
			this.fgl_detalle = false;
			this.isEmpty = true;
			this.fgl_generado = false;
			this.isLoading = true;
			this.selectionMode = false;
			this.selectedRows = []

			const currentSelections = [...this.selectedRows];

			Balance.getIntercos(this.vigencia, 1)
				.then((result) => {
					this.intercos = result.data.intercos

					if (this.intercos.length > 0) {
						this.f_filterCompany();
						this.fgl_generado = true

						if (currentSelections.length > 0) {
							this.selectedRows = currentSelections.filter(selected =>
								this.filteredIntercos.some(item =>
									item.identificacion_origen === selected.identificacion_origen &&
									item.identificacion_destino === selected.identificacion_destino
								)
							);

							if (this.selectedRows.length > 0) {
								this.$toast.info(`Se restauraron ${this.selectedRows.length} selección(es)`);
							}
						}
					} else {
						this.isEmpty = true
						this.selectedRows = [];
						this.$toast.info("No se encontraron datos para la vigencia seleccionada")
					}
				})
				.catch((error) => {
					this.error = true
					this.isEmpty = true
					this.selectedRows = [];
					this.$toast.error("Error al consultar los datos")
					console.error("Error en f_consultar:", error)
				})
				.finally(() => {
					this.isLoading = false
				})
		},

		f_generar_detalle(p_identificacion_origen, p_identificacion_destino) {
			this.isLoading = true

			Balance.getIntercosDetalle(this.vigencia, p_identificacion_origen, p_identificacion_destino, this.dialogReportes)
				.then((result) => {
					this.intercos_detalle = result.data.intercos_detalle
					this.fgl_detalle = true
					this.fgl_diferencia = false

					this.titulo_cuenta = `${this.f_compania(p_identificacion_origen)} → ${this.f_compania(p_identificacion_destino)}`
				})
				.catch((error) => {
					this.error = true
					this.$toast.error("Error al cargar el detalle")
					console.error("Error en f_generar_detalle:", error)
				})
				.finally(() => {
					this.isLoading = false
				})
		},

		formato(numero) {
			if (numero === null || numero === undefined) return "0"
			return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(numero)
		},

		f_compania(p_identificacion) {
			if (p_identificacion == undefined || p_identificacion == null) {
				return "Nombre " + p_identificacion
			}
			const v_compañia = this.companias.find((compañia) => compañia.identificacion == p_identificacion)
			if (v_compañia == undefined) {
				return "Nombre " + p_identificacion
			}
			return v_compañia.nombre
		},

		excel(opcion) {
			let datos = {}
			datos.reporte = "Saldos Interco"
			datos.vigencia = this.vigencia
			datos.opcion = opcion
			datos.userId = this.$store.state.userId
			datos.userName = this.$store.state.userName
			if (opcion === 1) {
				datos.compania = "RESUMIDO"
				datos.titulo = this.f_titulo()
				datos.informacion = this.filteredIntercos
				this.hojaExcelInterco(datos)
			}
			if (opcion === 2) {
				datos.compania = "POR CUENTA"
				datos.titulo = this.f_titulo_cuenta()
				datos.informacion = this.intercos_detalle
				this.hojaExcelInterco(datos)
			}
		},

		async hojaExcelInterco(datos) {
			let createdAt1 = new Date()
			let anio = createdAt1.getFullYear()
			let mes = String(createdAt1.getMonth() + 1).padStart(2, '0')
			let dia = String(createdAt1.getDate()).padStart(2, '0')
			let createdAt = anio + "-" + mes + "-" + dia

			let reporte = datos.reporte
			let compania = datos.compania
			let vigencia = datos.vigencia
			let titulo = datos.titulo
			let userName = datos.userName
			const filas = datos.informacion

			const { Workbook } = XLSX
			const workbook = new Workbook()
			const worksheet = workbook.addWorksheet("Intercompañías")

			const styles = {
				tituloPrincipal: {
					font: { name: "Calibri", size: 16, bold: true },
					alignment: { horizontal: "center", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } },
					border: {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					}
				},
				subtitulo: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } },
					border: {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					}
				},
				encabezado: {
					font: { name: "Calibri", size: 11, bold: true, color: { argb: "000000" } },
					alignment: { horizontal: "center", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F2F2F2" } },
					border: {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					}
				},
				datoNormal: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "left", vertical: "middle" },
					border: {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					}
				},
				numeroNormal: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					border: {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					}
				},
				grupoSeleccion: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "left", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F2F2F2" } },
					border: {
						top: { style: "thin" },
						left: { style: "thin" },
						bottom: { style: "thin" },
						right: { style: "thin" }
					}
				}
			}

			let headerColumns = 7;
			if (datos.opcion === 2) headerColumns = 8;
			if (datos.opcion === 3) headerColumns = 9;

			worksheet.mergeCells(`A1:${String.fromCharCode(64 + headerColumns)}1`)
			worksheet.getCell('A1').value = titulo
			Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal)
			worksheet.getCell('A1').font.color = { argb: "000000" }

			worksheet.mergeCells(`A2:${String.fromCharCode(64 + headerColumns)}2`)
			worksheet.getCell('A2').value = `Vigencia: ${vigencia} | ${compania}`
			Object.assign(worksheet.getCell('A2'), styles.subtitulo)

			worksheet.mergeCells(`A3:${String.fromCharCode(64 + headerColumns)}3`)
			worksheet.getCell('A3').value = `Generado: ${createdAt} por ${userName} | Reporte: ${reporte}`
			Object.assign(worksheet.getCell('A3'), styles.subtitulo)

			worksheet.addRow([])

			let HEADER_ROW = [];
			let col_origen = 0;
			let col_destino = 0;
			let columnWidths = [];

			if (datos.opcion === 1) {
				HEADER_ROW = [
					'NIT ORIGEN',
					'COMPAÑÍA ORIGEN',
					'SALDO ORIGEN',
					'NIT DESTINO',
					'COMPAÑÍA DESTINO',
					'SALDO DESTINO',
					'DIFERENCIA'
				];
				col_origen = 2;
				col_destino = 5;
				columnWidths = [
					{ width: 15 },
					{ width: 25 },
					{ width: 18 },
					{ width: 15 },
					{ width: 25 },
					{ width: 18 },
					{ width: 18 }
				];
			} else if (datos.opcion === 2) {
				HEADER_ROW = [
					'NIT ORIGEN',
					'CUENTA ORIGEN',
					'DESCRIPCIÓN ORIGEN',
					'SALDO ORIGEN',
					'NIT DESTINO',
					'CUENTA DESTINO',
					'DESCRIPCIÓN DESTINO',
					'SALDO DESTINO'
				];
				col_origen = 3;
				col_destino = 7;
				columnWidths = [
					{ width: 15 },
					{ width: 15 },
					{ width: 35 },
					{ width: 18 },
					{ width: 15 },
					{ width: 15 },
					{ width: 35 },
					{ width: 18 }
				];
			} else if (datos.opcion === 3) {
				HEADER_ROW = [
					'GRUPO SELECCIÓN',
					'NIT ORIGEN',
					'CUENTA ORIGEN',
					'DESCRIPCIÓN ORIGEN',
					'SALDO ORIGEN',
					'NIT DESTINO',
					'CUENTA DESTINO',
					'DESCRIPCIÓN DESTINO',
					'SALDO DESTINO'
				];
				col_origen = 4;
				col_destino = 8;
				columnWidths = [
					{ width: 30 },
					{ width: 15 },
					{ width: 15 },
					{ width: 30 },
					{ width: 18 },
					{ width: 15 },
					{ width: 15 },
					{ width: 30 },
					{ width: 18 }
				];
			}

			const headerRow = worksheet.addRow(HEADER_ROW)
			headerRow.eachCell((cell) => {
				Object.assign(cell, styles.encabezado)
			})

			worksheet.columns = columnWidths;

			let n_fila = 6

			if (datos.opcion === 1) {
				filas.forEach((fila) => {
					let v_fila = [
						fila.identificacion_origen,
						this.f_compania(fila.identificacion_origen),
						fila.saldo_origen == null ? null : parseFloat(fila.saldo_origen),
						fila.identificacion_destino,
						this.f_compania(fila.identificacion_destino),
						fila.saldo_destino == null ? null : parseFloat(fila.saldo_destino),
						this.f_calcularDiferencia(fila.saldo_origen, fila.saldo_destino)
					]

					const currentRow = worksheet.addRow(v_fila)

					currentRow.eachCell((cell, colNumber) => {
						if (colNumber === col_origen + 1 || colNumber === col_destino + 1 || colNumber === 7) {
							Object.assign(cell, styles.numeroNormal)
						} else {
							Object.assign(cell, styles.datoNormal)
						}
					})

					n_fila++
				})
			} else if (datos.opcion === 2) {
				filas.forEach((fila) => {
					let v_fila = [
						fila.identificacion_origen,
						fila.cuenta_origen,
						fila.descripcion_origen,
						fila.saldo_origen == null ? null : parseFloat(fila.saldo_origen),
						fila.identificacion_destino,
						fila.cuenta_destino,
						fila.descripcion_destino,
						fila.saldo_destino == null ? null : parseFloat(fila.saldo_destino)
					]

					const currentRow = worksheet.addRow(v_fila)

					currentRow.eachCell((cell, colNumber) => {
						if (colNumber === col_origen + 1 || colNumber === col_destino + 1) {
							Object.assign(cell, styles.numeroNormal)
						} else {
							Object.assign(cell, styles.datoNormal)
						}
					})

					n_fila++
				})
			} else if (datos.opcion === 3) {
				let grupoActual = "";

				filas.forEach((fila) => {
					if (fila.selection_group !== grupoActual) {
						if (grupoActual !== "") {
							worksheet.addRow([])
							n_fila++
						}

						grupoActual = fila.selection_group;

						worksheet.addRow([fila.selection_group])
						worksheet.mergeCells(`A${n_fila}:${String.fromCharCode(64 + headerColumns)}${n_fila}`)
						Object.assign(worksheet.getCell(`A${n_fila}`), styles.grupoSeleccion)
						n_fila++
					}

					let v_fila = [
						fila.selection_group,
						fila.identificacion_origen,
						fila.cuenta_origen,
						fila.descripcion_origen,
						fila.saldo_origen == null ? null : parseFloat(fila.saldo_origen),
						fila.identificacion_destino,
						fila.cuenta_destino,
						fila.descripcion_destino,
						fila.saldo_destino == null ? null : parseFloat(fila.saldo_destino)
					]

					const currentRow = worksheet.addRow(v_fila)

					currentRow.eachCell((cell, colNumber) => {
						if (colNumber === col_origen + 1 || colNumber === col_destino + 1) {
							Object.assign(cell, styles.numeroNormal)
						} else {
							Object.assign(cell, styles.datoNormal)
						}
					})

					n_fila++
				})
			}

			worksheet.views = [
				{ state: 'frozen', ySplit: 5 }
			]

			worksheet.autoFilter = {
				from: { row: 5, column: 1 },
				to: { row: 5, column: headerColumns }
			};

			const file = await workbook.xlsx.writeBuffer()
			const downloadLink = document.createElement("a")

			let fileName = "Intercompañias";
			if (datos.opcion === 1) fileName = "Intercompañias_Resumen";
			if (datos.opcion === 2) fileName = "Intercompañias_Detalle";
			if (datos.opcion === 3) fileName = "Intercompañias_Seleccion";

			downloadLink.download = `${fileName}_${vigencia}_${createdAt}.xlsx`

			downloadLink.href = window.URL.createObjectURL(
				new Blob([file], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				})
			)

			downloadLink.style.display = "none"
			document.body.appendChild(downloadLink)
			downloadLink.click()
			downloadLink.remove()
		},

		async verHuerfanos() {
			if (!this.dialogFechas) {
				this.$toast.warning("Por favor seleccione una vigencia");
				return;
			}

			this.isLoading = true;

			try {
				const response = await Balance.getIntercosHuerfanos(this.dialogFechas);
				console.log("Respuesta COMPLETA del endpoint:", response);
				console.log("response.data:", response.data);
				console.log("response.data.huerfanos:", response.data.huerfanos);

				// Si viene en otra estructura, intenta también
				console.log("response.data[0]:", response.data[0]);

				const huerfanos = response.data.huerfanos || response.data[0] || [];

				console.log("Huérfanos extraídos:", huerfanos);
				console.log("Cantidad:", huerfanos.length);

				if (!huerfanos || huerfanos.length === 0) {
					this.$toast.info("No se encontraron registros sin conciliar");
					this.isLoading = false;
					return;
				}

				const datos = {
					reporte: "Intercos Sin Conciliar",
					vigencia: this.dialogFechas,
					opcion: 4,
					userId: this.$store.state.userId,
					userName: this.$store.state.userName,
					compania: "SIN CONCILIAR",
					titulo: "REGISTROS INTERCOMPAÑÍA SIN CONCILIAR",
					informacion: huerfanos
				};

				await this.hojaExcelIntercosHuerfanos(datos);
				this.$toast.success(`Excel generado con registro(s) sin conciliar`);

			} catch (error) {
				console.error("Error en verHuerfanos:", error);
				this.$toast.error("Error al generar el reporte de registros sin conciliar");
			} finally {
				this.isLoading = false;
			}
		},

		async hojaExcelIntercosHuerfanos(datos) {
			// Validar que informacion sea un array
			if (!datos.informacion || !Array.isArray(datos.informacion)) {
				console.error("datos.informacion no es un array:", datos.informacion);
				this.$toast.error("Error: Los datos no tienen el formato esperado");
				return;
			}

			let createdAt1 = new Date();
			let anio = createdAt1.getFullYear();
			let mes = String(createdAt1.getMonth() + 1).padStart(2, '0');
			let dia = String(createdAt1.getDate()).padStart(2, '0');
			let createdAt = anio + "-" + mes + "-" + dia;

			const { Workbook } = XLSX;
			const workbook = new Workbook();
			const worksheet = workbook.addWorksheet("Sin Conciliar");

			const styles = {
				tituloPrincipal: {
					font: { name: "Calibri", size: 16, bold: true },
					alignment: { horizontal: "center", vertical: "middle" },
					border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
				},
				subtitulo: {
					font: { name: "Calibri", size: 11, bold: true },
					alignment: { horizontal: "center", vertical: "middle" },
					border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
				},
				encabezado: {
					font: { name: "Calibri", size: 11, bold: true, color: { argb: "000000" } },
					alignment: { horizontal: "center", vertical: "middle" },
					fill: { type: "pattern", pattern: "solid", fgColor: { argb: "F2F2F2" } },
					border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
				},
				datoNormal: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "left", vertical: "middle" },
					border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
				},
				numeroNormal: {
					font: { name: "Calibri", size: 10 },
					alignment: { horizontal: "right", vertical: "middle" },
					numFmt: "#,##0",
					border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
				}
			};

			// Encabezados (10 columnas ahora)
			worksheet.mergeCells(`A1:J1`);
			worksheet.getCell('A1').value = datos.titulo;
			Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal);

			worksheet.mergeCells(`A2:J2`);
			worksheet.getCell('A2').value = `Vigencia: ${datos.vigencia}`;
			Object.assign(worksheet.getCell('A2'), styles.subtitulo);

			worksheet.mergeCells(`A3:J3`);
			worksheet.getCell('A3').value = `Generado: ${createdAt} por ${datos.userName} | Reporte: ${datos.reporte}`;
			Object.assign(worksheet.getCell('A3'), styles.subtitulo);

			worksheet.addRow([]);

			const HEADER_ROW = [
				'Vigencia', 'Secuencia', 'NIT Compañía', 'Compañía',
				'Cuenta', 'Descripción', 'Saldo Actual', 'Ajuste Actual',
				'NIT Contraparte', 'Compañía Contraparte'
			];

			const headerRow = worksheet.addRow(HEADER_ROW);
			headerRow.eachCell((cell) => {
				Object.assign(cell, styles.encabezado);
			});

			worksheet.columns = [
				{ width: 12 },   // Vigencia
				{ width: 12 },   // Secuencia
				{ width: 15 },   // NIT Compañía
				{ width: 35 },   // Compañía
				{ width: 15 },   // Cuenta
				{ width: 45 },   // Descripción
				{ width: 18 },   // Saldo Actual
				{ width: 18 },   // Ajuste Actual
				{ width: 15 },   // NIT Contraparte
				{ width: 35 }    // Compañía Contraparte
			];

			datos.informacion.forEach((fila) => {
				const v_fila = [
					fila.vigencia,
					fila.secuencia,
					fila.identificacion_compania,
					fila.nombre_compania,
					fila.cuenta,
					fila.descripcion,
					fila.saldo_actual == null ? 0 : parseFloat(fila.saldo_actual),
					fila.ajuste_actual == null ? 0 : parseFloat(fila.ajuste_actual),
					fila.identificacion_contraparte || '',
					fila.nombre_contraparte || ''
				];

				const currentRow = worksheet.addRow(v_fila);
				currentRow.eachCell((cell, colNumber) => {
					if (colNumber === 7 || colNumber === 8) { // Columnas de saldos
						Object.assign(cell, styles.numeroNormal);
					} else {
						Object.assign(cell, styles.datoNormal);
					}
				});
			});

			worksheet.views = [{ state: 'frozen', ySplit: 5 }];
			worksheet.autoFilter = { from: { row: 5, column: 1 }, to: { row: 5, column: 10 } };

			const file = await workbook.xlsx.writeBuffer();
			const downloadLink = document.createElement("a");
			downloadLink.download = `Sin_Conciliar_${datos.vigencia}_${createdAt}.xlsx`;
			downloadLink.href = window.URL.createObjectURL(new Blob([file], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));
			downloadLink.style.display = "none";
			document.body.appendChild(downloadLink);
			downloadLink.click();
			downloadLink.remove();
		},

		async excelSelection() {
			if (this.selectedRows.length === 0) {
				this.$toast.warning("No hay filas seleccionadas");
				return;
			}

			this.isLoading = true;

			try {
				const allDetails = [];

				for (const row of this.selectedRows) {
					const result = await Balance.getIntercosDetalle(
						this.vigencia,
						row.identificacion_origen,
						row.identificacion_destino,
						this.dialogReportes
					);

					const detailsWithId = result.data.intercos_detalle.map(detail => ({
						...detail,
						selection_group: `${row.compania_origen} - ${row.compania_destino}`
					}));

					allDetails.push(...detailsWithId);
				}

				let datos = {
					reporte: "Saldos Interco - Selección",
					vigencia: this.vigencia,
					opcion: 3,
					userId: this.$store.state.userId,
					userName: this.$store.state.userName,
					compania: "DETALLE POR SELECCIÓN",
					titulo: `Detalle de ${this.selectedRows.length} relación(es) seleccionada(s)`,
					informacion: allDetails
				};

				await this.hojaExcelInterco(datos);
				this.$toast.success(`Excel generado con ${this.selectedRows.length} relación(es)`);

				this.selectionMode = false;
				this.selectedRows = [];

			} catch (error) {
				console.error("Error en excelSelection:", error);
				this.$toast.error("Error al generar el Excel de selección");
			} finally {
				this.isLoading = false;
			}
		},
	},

	mounted() {
		Grupo.getAllGrupos()
			.then((result) => {
				this.listGrupos = result.data.grupos;
				console.log('Grupos cargados:', this.listGrupos);
			})
			.catch((error) => {
				console.error("Error al cargar los grupos:", error);
				this.$toast.error("Error al cargar los grupos");
			});

		Balance.getFechas()
			.then((result) => {
				this.fechas = result.data.fechas
				this.dialogFechas = ''
			})
			.catch(() => {
				this.error = true
				this.$toast.error("Error al cargar las vigencias")
			})

		this.isLoading = false
		Balance.getCompanias(true)
			.then((result) => {
				this.companias = result.data.companias
				console.log('Compañías cargadas para intercos:', this.companias);
			})
			.catch(() => {
				this.error = true
				this.$toast.error("Error al cargar las compañías")
			})

		Balance.getReportes()
			.then((result) => {
				this.reportes = result.data.reportes
			})
			.catch(() => {
				this.error = true
				this.$toast.error("Error al cargar los reportes")
			})

		this.isEmpty = true
		this.intercos = []
		this.filteredIntercos = []
	},
};
</script>

<style scoped>
.balance-table {
	font-size: 14px;
}

.balance-table>>>.md-table-head {
	padding: 8px 4px !important;
}

.balance-table>>>.md-table-cell {
	padding: 8px 4px !important;
	min-width: auto !important;
}

.principal-table>>>.md-table-cell:nth-child(1),
.principal-table>>>.md-table-cell:nth-child(4) {
	width: 120px !important;
	max-width: 120px !important;
}

.principal-table>>>.md-table-cell:nth-child(2),
.principal-table>>>.md-table-cell:nth-child(5) {
	width: 200px !important;
	max-width: 200px !important;
	white-space: normal !important;
	overflow: visible !important;
	text-overflow: unset !important;
	word-wrap: break-word !important;
	line-height: 1.2 !important;
	height: auto !important;
	min-height: 40px !important;
}

.principal-table>>>.md-table-cell:nth-child(3),
.principal-table>>>.md-table-cell:nth-child(6),
.principal-table>>>.md-table-cell:nth-child(7) {
	width: 150px !important;
	max-width: 150px !important;
}

.principal-table>>>.md-table-cell:nth-child(8) {
	width: 180px !important;
	max-width: 180px !important;
	min-width: 100px !important;
	font-size: 12px !important;
	white-space: normal !important;
	word-wrap: break-word !important;
	line-height: 1.3 !important;
}

.detalle-table>>>.md-table-cell:nth-child(1),
.detalle-table>>>.md-table-cell:nth-child(5) {
	width: 100px !important;
	max-width: 100px !important;
}

.detalle-table>>>.md-table-cell:nth-child(2),
.detalle-table>>>.md-table-cell:nth-child(6) {
	width: 120px !important;
	max-width: 120px !important;
}

.detalle-table>>>.md-table-cell:nth-child(3),
.detalle-table>>>.md-table-cell:nth-child(7) {
	width: 300px !important;
	max-width: 300px !important;
	white-space: normal !important;
	word-wrap: break-word !important;
	line-height: 1.2 !important;
}

.detalle-table>>>.md-table-cell:nth-child(4),
.detalle-table>>>.md-table-cell:nth-child(8) {
	width: 150px !important;
	max-width: 150px !important;
}

.detalle-table>>>.md-table-content {
	min-width: 1200px !important;
}

.balance-table>>>.md-table {
	width: 100% !important;
	table-layout: fixed !important;
}

.balance-table>>>.md-table-toolbar {
	min-height: 60px !important;
	padding: 8px 16px !important;
}

.px-3 {
	padding-left: 1rem !important;
	padding-right: 1rem !important;
}

.excel-btn {
	min-width: 160px !important;
	height: 40px !important;
	display: flex !important;
	align-items: center !important;
	justify-content: center !important;
	gap: 8px !important;
	margin: 0 4px !important;
	border: none !important;
	font-weight: 600 !important;
}

.excel-btn-text {
	font-size: 14px !important;
	font-weight: 600 !important;
}

.excel-btn.btn-success {
	background-color: #217346 !important;
	border: 1px solid #1a5c38 !important;
}

.excel-btn.btn-info {
	background-color: #2c5f7a !important;
	border: 1px solid #234c61 !important;
}

.excel-btn.download-btn,
.excel-btn.btn-success.download-btn {
    background-color: #4a90e2 !important;
    border: 1px solid #3a7bc8 !important;
    color: white !important;
    animation: pulse 2s infinite;
}

.excel-btn.btn-warning {
    background-color: #ffc107 !important;
    border: 1px solid #e0a800 !important;
    color: white !important;
}

.excel-btn.download-btn:hover,
.excel-btn.btn-success.download-btn:hover {
    background-color: #3a7bc8 !important;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    filter: brightness(1.1);
}

.excel-btn.btn-warning:hover {
    background-color: #e0a800 !important;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    filter: brightness(1.1);
    color: white !important;
}

.excel-btn:not(.download-btn):not(.btn-warning):not(:disabled):hover {
	transform: translateY(-1px);
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
	filter: brightness(1.1);
}

.excel-btn:disabled {
	background-color: #cccccc !important;
	border-color: #bbbbbb !important;
	opacity: 0.6 !important;
	color: #666666 !important;
}

.selected-row {
	background-color: #e8f4fd !important;
	border-left: 3px solid #2c5f7a !important;
}

.selection-mode-row {
	cursor: pointer !important;
}

.selection-mode-row:hover {
	background-color: #f8f9fa !important;
}

.alert-info {
	background-color: #d1ecf1 !important;
	border-color: #bee5eb !important;
	color: #0c5460 !important;
	padding: 10px 15px !important;
	border-radius: 5px !important;
}

.principal-table>>>.md-table-row {
	transition: all 0.2s ease;
}

.principal-table>>>.md-table-row:hover {
	background-color: #f5f5f5 !important;
}

</style>

<style src="../main.css"></style>
